module.exports = __webpack_public_path__ + "img/share.f02869da.png";